module.exports = __webpack_public_path__ + "img/asset_ETH.768fa7f9.svg";